import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useToast } from "@aviary";
import { useDebounce } from "@shared/hooks";
import { gRecaptchaExecute } from "@shared/utils";
import { useUserExistingAccountCheck } from "@unauthenticated/shared/data/mutations";
import { l } from "@unauthenticated/shared/locales/i18n";

const useAccountExistsCheck = (initialValue = false) => {
  const [isAccountExists, setIsAccountExists] = useState(initialValue);
  const { makeToast } = useToast();
  const { t } = useTranslation();

  const [checkIfAccountExists, { loading: isAccountCheckLoading }] = useUserExistingAccountCheck({
    onCompleted: completedData => {
      const isAccountExist = completedData?.auth?.userExistingAccountCheck?.accountExists;
      const captchaError = completedData?.auth?.userExistingAccountCheck?.errors?.message;
      setIsAccountExists(isAccountExist);
      if (captchaError?.match(/captcha/gi)) {
        makeToast("error", t(l.signIn.CaptchaFailed), { autoDismiss: false });
      }
    },
    onError: ({ message }) => {
      makeToast("error", message);
    },
  });

  const checkIfAccountExistsWithRecaptcha = (email: string) => {
    gRecaptchaExecute(captchaToken =>
      checkIfAccountExists({
        variables: {
          input: {
            captchaToken,
            attributes: {
              email,
            },
          },
        },
      })
    );
  };

  const handleCheckIfAccountExists = useDebounce(checkIfAccountExistsWithRecaptcha, 500);

  return {
    isAccountExists,
    setIsAccountExists,
    handleCheckIfAccountExists,
    checkIfAccountExistsWithRecaptcha,
    isAccountCheckLoading,
  };
};

export { useAccountExistsCheck };
